import { MultiReportUploadPanel } from "@/components/multi_report_upload_panel"

/** The server's `MAX_UPLOAD_SIZE` is 150 MB; leave headroom for multipart encoding. */
const KROGER_UPLOAD_MAX_BYTES = 149 * 1024 * 1024

const CSV = { "text/csv": [".csv"] }

interface KrogerUploadSectionProps {
  integrationId: string
  onUploaded: () => void
}

/** Upload the three PartnerPass CSVs, plus any backup zips; queues a `sync-kroger` job. */
export function KrogerUploadSection({ integrationId, onUploaded }: KrogerUploadSectionProps) {
  return (
    <MultiReportUploadPanel
      endpoint="/api/admin/kroger/upload"
      fields={{ integration_id: integrationId }}
      maxTotalBytes={KROGER_UPLOAD_MAX_BYTES}
      slots={[
        {
          field: "export_grid",
          title: "Export Grid",
          description: "Transactions tab → download icon → Export grid → CSV.",
          accept: CSV,
          required: true,
        },
        {
          field: "invoice_deductions",
          title: "Invoice Deductions",
          description: "Transactions tab → download icon → Download deductions (CSV).",
          accept: CSV,
          required: true,
        },
        {
          field: "promo_lines",
          title: "Promotion Lines",
          description: "Transactions tab → download icon → Download promo lines (CSV).",
          accept: CSV,
          required: true,
        },
        {
          field: "pdf_backups",
          title: "PDF backup zips (recommended)",
          description:
            "Invoices tab → set the page size to 1,000 → Select all → export backup PDFs. Add as many zips as you have.",
          accept: { "application/zip": [".zip"], "application/x-zip-compressed": [".zip"] },
          multiple: true,
        },
      ]}
      successMessage={() => ({
        title: "Upload received",
        description: "Your Kroger deductions will sync in the background.",
      })}
      onUploaded={onUploaded}>
      <div class="rounded-md border border-blue-200 bg-blue-50 p-3 text-sm text-blue-900 space-y-2">
        <p>
          Export these files from{" "}
          <a
            href="https://partnerpass.krogerapps.com"
            target="_blank"
            rel="noopener noreferrer"
            class="underline hover:text-blue-700">
            Kroger PartnerPass
          </a>
          . Select <strong>Standard</strong> from the dropdown in the top right first. All three CSVs come from the{" "}
          <strong>download icon</strong> on the Transactions tab.
        </p>
      </div>
    </MultiReportUploadPanel>
  )
}
